class SlideOutClass {
  constructor(slideOutElement, openButton, closeButton) {
    this.slideOutElement = slideOutElement;
    this.openButton = openButton;
    this.closeButton = closeButton;

    this.openSlideOut = this.openSlideOut.bind(this);
    this.closeSlideOut = this.closeSlideOut.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.openButton.addEventListener("click", this.openSlideOut);
    this.closeButton.addEventListener("click", this.closeSlideOut);
    this.slideOutElement.addEventListener("keydown", this.handleKeyDown);
  }

  openSlideOut() {
    this.slideOutElement.classList.add("active");
    this.slideOutElement.setAttribute("aria-hidden", "false");
    // Remove tabindex -1
    this.closeButton.removeAttribute("tabindex");
    const firstTabbableElement = this.slideOutElement.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    if (firstTabbableElement) {
      setTimeout(() => {
        firstTabbableElement.focus();
      }, 100); // Adjust the delay as needed
    }
    this.slideOutElement.closest("body").classList.add("overflow-hidden");

    // Trap focus within slideout
    const focusableElements = this.slideOutElement.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    this.slideOutElement.addEventListener("keydown", (event) => {
      if (event.key === "Tab") {
        if (event.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
  }

  closeSlideOut() {
    this.slideOutElement.classList.remove("active");
    this.slideOutElement.setAttribute("aria-hidden", "true");
    this.openButton.focus();
    this.slideOutElement.closest("body").classList.remove("overflow-hidden");

    // Remove trap focus
    this.slideOutElement.removeEventListener("keydown", this.handleKeyDown);
    // Add tabindex -1 to make it unfocusable again
    this.closeButton.setAttribute("tabindex", "-1");
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.closeSlideOut();
    }
  }
}
